import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Secant feature parameters */
export interface SecantParams {
  /** Reference to parent function element */
  of: string;
  /** X-coordinate of the start point */
  xStart: number;
  /** X-coordinate of the end point */
  xEnd: number;
  /** Whether the line is finite (segment) or infinite */
  finite?: boolean;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const SECANT_DEFAULT_PARAMS: Omit<SecantParams, 'of'> = {
  xStart: -1,
  xEnd: 1,
  finite: false,
};

/**
 * Default theme for secant feature.
 * pink colored line and points.
 *
 * Subparts:
 * - `startPoint`: First glider on the curve (draggable by default)
 * - `endPoint`: Second glider on the curve (draggable by default)
 * - `secantLine`: The line connecting the two points
 * - `rateTriangle`: Container for the rate of change triangle
 *   - `horizontalLine`: Horizontal line showing delta-x
 *   - `verticalLine`: Vertical line showing delta-y
 *   - `cornerPoint`: The corner point (hidden by default)
 */
export const SECANT_DEFAULTS: FeatureStyleNode = {
  line: { color: 'pink', strokeWidth: 2 },
  point: { color: 'pink', fixed: true },
  subparts: {
    startPoint: { point: { color: 'pink', fixed: true } },
    endPoint: { point: { color: 'pink', fixed: true } },
    secantLine: { line: { color: 'pink', strokeWidth: 2 } },
    rateTriangle: {
      subparts: {
        horizontalLine: { visible: false, line: { color: 'pink', strokeWidth: 2, dash: 2 } },
        verticalLine: { visible: false, line: { color: 'pink', strokeWidth: 2, dash: 2 } },
        cornerPoint: { point: { color: 'pink' }, visible: false },
      },
    },
  },
};
